import apiClient from '@/services/axios'

export async function del(eventId) {

  var response = await apiClient.delete(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/events/' + eventId);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to delete event.')
}
